import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FileText, Download, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api, { formatErrorMessage } from '../utils/api';

const FICHAS = [
  {
    slug: 'comercial-marketing',
    titulo: 'Comercial & Marketing',
    descripcion: 'Pipeline de leads, campañas, embudo, integraciones Meta/Google, state machine y SLAs.',
    filename: 'Ficha_Tecnica_Comercial_Marketing_Peritum.pdf',
  },
  {
    slug: 'cerebro-tareas',
    titulo: 'Cerebro de Tareas',
    descripcion: 'Procesamiento IA de minutas, estados de tarea, motor de aprendizaje (13 fases) y motor Shadow.',
    filename: 'Ficha_Tecnica_Cerebro_de_Tareas_Peritum.pdf',
  },
  {
    slug: 'master-clientes',
    titulo: 'Master de Clientes',
    descripcion: 'Fuente única de verdad: identidad, empresas asociadas, ciclo de vida, credenciales sensibles y permisos.',
    filename: 'Ficha_Tecnica_Master_Clientes_Peritum.pdf',
  },
  {
    slug: 'cobranzas',
    titulo: 'Cobranzas',
    descripcion: 'Estado de cuenta (cartola), alertas por antigüedad, comunicaciones (plantillas/estados/recordatorios) y minutas semanales.',
    filename: 'Ficha_Tecnica_Cobranzas_Peritum.pdf',
  },
  {
    slug: 'panel-aprendizaje',
    titulo: 'Panel de Aprendizaje',
    descripcion: 'Motor de aprendizaje del Cerebro: 13 fases, patrones detectados, sugerencias IA, motor Shadow y ciclo de reforzamiento.',
    filename: 'Ficha_Tecnica_Panel_Aprendizaje_Peritum.pdf',
  },
];

const FichasTecnicasCard = () => {
  const [descargando, setDescargando] = useState(null);

  const descargar = async (ficha) => {
    setDescargando(ficha.slug);
    try {
      const res = await api.get(`/descargas/fichas-tecnicas/${ficha.slug}`, { responseType: 'blob' });
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = ficha.filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success(`Descargando ${ficha.titulo}`);
    } catch (e) {
      toast.error(`Error al descargar: ${formatErrorMessage(e)}`);
    } finally {
      setDescargando(null);
    }
  };

  return (
    <Card className="p-6 border-slate-200" data-testid="fichas-tecnicas-card">
      <h3 className="font-semibold text-slate-900 mb-1 flex items-center gap-2">
        <FileText className="w-5 h-5 text-indigo-600" />
        Fichas Técnicas del Sistema
      </h3>
      <p className="text-sm text-slate-500 mb-4">
        Documentos PDF con el detalle operativo y de diseño de cada módulo. Útiles para compartir con consultores de arquitectura o auditoría.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {FICHAS.map((ficha) => (
          <div
            key={ficha.slug}
            className="border border-slate-200 rounded-lg p-4 flex items-start gap-3 hover:border-indigo-400 hover:bg-indigo-50/40 transition"
            data-testid={`ficha-${ficha.slug}`}
          >
            <div className="flex-shrink-0 w-10 h-10 rounded-md bg-indigo-100 text-indigo-700 flex items-center justify-center">
              <FileText className="w-5 h-5" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-slate-900 text-sm">{ficha.titulo}</p>
              <p className="text-xs text-slate-500 mb-3 leading-snug">{ficha.descripcion}</p>
              <Button
                size="sm"
                variant="outline"
                className="h-8"
                onClick={() => descargar(ficha)}
                disabled={descargando === ficha.slug}
                data-testid={`descargar-ficha-${ficha.slug}`}
              >
                {descargando === ficha.slug ? (
                  <>
                    <Loader2 className="w-3.5 h-3.5 mr-2 animate-spin" /> Descargando…
                  </>
                ) : (
                  <>
                    <Download className="w-3.5 h-3.5 mr-2" /> Descargar PDF
                  </>
                )}
              </Button>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default FichasTecnicasCard;
